import React, { useEffect, useRef } from 'react';
import useGameStore from '@store/useGameStore';
import useAuthStore from '@store/useAuthStore';
import useUiEffectsStore from '@store/useUiEffectsStore'; // ✅ 1. Importamos el store de UI
import { GameStatus } from '@utils/enums';
import BigTitle from '@components/ui/general/big-title/BigTitle';

const PhaseContainer = () => {
  // Subscribe to game status only for triggering effect
  const gameStatus = useGameStore((s) => s.game?.status);

  // ✅ 2. Leemos el estado del título y la acción desde nuestro nuevo store
  const { isTitleVisible, titleText, showBigTitle } = useUiEffectsStore();

  const prevStatusRef = useRef();
  const hasShownFinishMessage = useRef(false);

  // Este efecto detecta el cambio de fase y llama a la acción del store
  useEffect(() => {
    // Get current game state using snapshot pattern
    const gameState = useGameStore.getState();
    const game = gameState.game;
    const winningTeam = game?.winning_team;

    // Get current user to determine if they won or lost
    const authState = useAuthStore.getState();
    const user = authState.user;
    const currentPlayer = game?.players?.find((p) => p.user_id === user?.id);
    const playerTeam = currentPlayer?.pivot?.team;

    const previousStatus = prevStatusRef.current;

    // Handle game finish state with victory/defeat message
    if (gameStatus === GameStatus.FINISH) {
      // Show victory/defeat message only once per game finish
      if (!hasShownFinishMessage.current) {
        if (winningTeam === null || winningTeam === undefined) {
          throw new Error('[PhaseManager] Game finished but winning_team is missing!');
        }
        if (playerTeam === undefined) {
          throw new Error('[PhaseManager] Game finished but player team is missing!');
        }

        const message = winningTeam === playerTeam ? 'Victory!' : 'Defeat!';
        showBigTitle(message);
        hasShownFinishMessage.current = true;
      }
      // Always update ref to current status
      prevStatusRef.current = gameStatus;
      return;
    }

    // Reset the flag when game is not finished
    hasShownFinishMessage.current = false;

    // Skip if status hasn't changed
    if (previousStatus === gameStatus) return;

    // Phase transitions - only show titles for significant moments
    // Planning/Resolution titles removed for faster gameplay flow
    // The UI already shows phase changes via GameProgressBar animation

    prevStatusRef.current = gameStatus;
  }, [gameStatus, showBigTitle]);

  // ✅ 4. ¡Hemos eliminado toda la lógica de estado local y el useEffect de depuración!
  // El componente ahora es mucho más simple.

  return (
    <BigTitle 
      text={titleText} 
      show={isTitleVisible} 
    />
  );
};

export default PhaseContainer;